import { DateField, SelectField, TextField } from 'Components';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

const GlobalSearchDesktopOrders = props => (
  <Fragment>
    <div>
      <TextField name="OrderNumber" title={i18n.t('globalSearch:Order #')} value={props.formData.OrderNumber} onChange={props.onFormChange} />
      <TextField name="InvoiceToAttention" title={i18n.t('globalSearch:Invoice Attention')} value={props.formData.InvoiceToAttention} onChange={props.onFormChange} />
      <SelectField name="SubmissionTypeId" title={i18n.t('globalSearch:Submission Type')} value={props.formData.SubmissionTypeId} onChange={props.onFormChange} options={props.submissionTypeOptions} />
    </div>
    <div>
      <TextField name="ProjectNumber" title={i18n.t('globalSearch:Project #')} value={props.formData.ProjectNumber} onChange={props.onFormChange} />
      <TextField name="ReportToAttention" title={i18n.t('globalSearch:Report Attention')} value={props.formData.ReportToAttention} onChange={props.onFormChange} />
      <SelectField name="ClientNumber" title={i18n.t('globalSearch:Client')} value={props.formData.ClientNumber} onChange={props.onFormChange} options={props.clientOptions} />
    </div>
    <div>
      <TextField name="SiteLocationOrSiteNumber" title={i18n.t('globalSearch:Site Location / Site #')} value={props.formData.SiteLocationOrSiteNumber} onChange={props.onFormChange} />
      <TextField name="CreatedBy" title={i18n.t('globalSearch:Ordered By')} value={props.formData.CreatedBy} onChange={props.onFormChange} />
      <SelectField name="DateType" title={i18n.t('globalSearch:Date Type')} value={props.formData.DateType} onChange={props.onFormChange} options={props.dateTypeOrderOptions} />
    </div>
    <div>
      <TextField name="POAFENumber" title={i18n.t('globalSearch:PO #')} value={props.formData.POAFENumber} onChange={props.onFormChange} />
      <TextField name="WayBill" title={i18n.t('globalSearch:Waybill')} value={props.formData.WayBill} onChange={props.onFormChange} />
      <div className="global-search__desktop__container__grid__split">
        <DateField name="DateFrom" title={i18n.t('globalSearch:From')} value={props.formData.DateFrom} onChange={props.onFormChange} />
        <DateField name="DateTo" title={i18n.t('globalSearch:To')} value={props.formData.DateTo} onChange={props.onFormChange} />
      </div>
    </div>
  </Fragment>
);

GlobalSearchDesktopOrders.propTypes = {
  onFormChange: PropTypes.func,
  formData: PropTypes.shape({
    SampleID: PropTypes.string,
    OrderNumber: PropTypes.string,
    CreatedBy: PropTypes.string,
    WayBill: PropTypes.string,
    MaxxamJobNumber: PropTypes.string,
    MaxxamSampleNumber: PropTypes.string,
    ECoCNumber: PropTypes.string,
    CoCNumber: PropTypes.string,
    Attention: PropTypes.string,
    Status: PropTypes.string,
    invoiceNumber: PropTypes.string,
    Description: PropTypes.string,
    InvoiceToAttention: PropTypes.string,
    SubmissionTypeId: PropTypes.number,
    ProjectNumber: PropTypes.string,
    ReportToAttention: PropTypes.string,
    ClientNumber: PropTypes.string,
    SiteLocationOrSiteNumber: PropTypes.string,
    CreatedByName: PropTypes.string,
    DateType: PropTypes.string,
    POAFENumber: PropTypes.string,
    ModifiedByName: PropTypes.string,
    DateFrom: PropTypes.string,
    DateTo: PropTypes.string,
  }),
  clientOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })),
  submissionTypeOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  })),
  dateTypeOrderOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })),
};

export default GlobalSearchDesktopOrders;



// WEBPACK FOOTER //
// ./src/components/GlobalSearch/GlobalSearchDesktop/GlobalSearchDesktopOrders/GlobalSearchDesktopOrders.jsx